// src/store/errorMessage.js
// Extracts a readable message from an axios error, including DRF field
// validation errors (e.g. { distributor: ["This field is required."] }),
// which don't carry a top-level `detail` key. Mirrors the pattern used in
// aitimeSlice's createProvisioning handler.
export const errorMessage = (error) => {
  const data = error.response?.data;
  if (data) {
    if (typeof data === 'object' && !data.detail) {
      const fieldMessages = Object.entries(data)
        .map(([field, messages]) => {
          const text = Array.isArray(messages) ? messages.join(', ') : messages;
          // non_field_errors isn't a real field name, so don't prefix it -
          // just show the message(s) as-is.
          return field === 'non_field_errors' ? text : `${field}: ${text}`;
        })
        .join('; ');
      if (fieldMessages) {
        return fieldMessages;
      }
    }
    return data.detail || data.error || data.message || error.message;
  }
  return error.message || 'An unexpected error occurred';
};
